import { formatCurrency } from '../utils/utils';
import type { TaxBreakdown } from '../utils/vat';

export interface TaxBreakdownSummaryProps {
  breakdown: TaxBreakdown;
  className?: string;
  compact?: boolean;
}

export function TaxBreakdownSummary({
  breakdown,
  className = '',
  compact = false,
}: TaxBreakdownSummaryProps) {
  const rowClass = compact
    ? 'flex justify-between text-xs text-gray-600'
    : 'flex justify-between text-sm text-gray-600';
  const totalClass = compact
    ? 'flex justify-between pt-2 mt-2 border-t border-gray-200 text-sm font-semibold text-gray-900'
    : 'flex justify-between pt-2 mt-2 border-t border-gray-200 text-base font-bold text-blue-600';

  return (
    <div className={className}>
      <div className={rowClass}>
        <span>Summa exkl. moms</span>
        <span>{formatCurrency(breakdown.amount_excl_vat)}</span>
      </div>
      <div className={rowClass}>
        <span>Moms {breakdown.vat_rate}%</span>
        <span>{formatCurrency(breakdown.vat_amount)}</span>
      </div>
      <div className={totalClass}>
        <span>Totalt inkl. moms</span>
        <span>{formatCurrency(breakdown.amount_incl_vat)}</span>
      </div>
    </div>
  );
}
